"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _link = require("@meepshop/link");

var _Sensor = _interopRequireDefault(require("@meepshop/context/lib/Sensor"));

var _GoToButton = _interopRequireDefault(require("./GoToButton"));

var _BackToTop = _interopRequireDefault(require("./BackToTop"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// typescript import
// import
require("./styles/index.less");

var styles = {
  "root": "meepshop-action-button__index__root"
}; // typescript definition

// definition
var _default = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var backToTopButtonEnabled = _ref.backToTopButtonEnabled,
      goToButton = _ref.goToButton;
  var router = (0, _link.useRouter)();

  var _useContext = (0, _react.useContext)(_Sensor["default"]),
      isMobile = _useContext.isMobile;

  var isBackToTopHidden = !backToTopButtonEnabled || !isMobile && router.pathname === '/checkout';
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.root
  }, /*#__PURE__*/_react["default"].createElement(_GoToButton["default"], {
    goToButton: goToButton
  }), isBackToTopHidden ? null : /*#__PURE__*/_react["default"].createElement(_BackToTop["default"], null));
});

exports["default"] = _default;